import CasAccordion from '@customer/components/accordions/accordion/CasAccordion';
import { AssetConfigurationAccordion } from '@customer/store/slices/globalSlice';
import { useTranslation } from 'react-i18next';
import { AccordionStatus } from '@customer/components/accordions/types';
import AccordionHeader from '@customer/components/accordions/header/AccordionHeader';
import AccordionTable from '@customer/components/accordions/table/AccordionTable';
import { GridControlled } from '@customer/components/tables/grid/GridControlled';
import { GeofenceData } from '@customer/hooks/assets/useAssetGeofenceTableData';
import { RowClassParams, RowClassRules } from 'ag-grid-community';
import { lockColumn } from '@customer/components/tables/grid/columnDefs';
import { useAssetGeofenceColDefs } from './useAssetGeofenceColDefs';

const gridSliceKeyGeofence = 'AssetPanelGeofence';

const geofenceRowClassRules: RowClassRules<GeofenceData> = {
  'dm-bold-row': (params: RowClassParams<GeofenceData>) => Boolean(params.data?.error),
};

export interface GeofenceStatusProps {
  geofenceData: GeofenceData[];
  good: boolean;
  expanded: boolean;
  transGood?: string;
  transBad?: string;
}

export function GeofenceStatus({
  geofenceData,
  good,
  expanded,
  transGood,
  transBad,
}: GeofenceStatusProps) {
  const { t } = useTranslation();

  const columnDefsGeofences = useAssetGeofenceColDefs();

  const getRowIdGeofence = (data: GeofenceData) => data.where;

  return (
    <CasAccordion
      key={AssetConfigurationAccordion.GeofenceStatus}
      defaultExpanded={expanded}
      status={good ? AccordionStatus.Healthy : AccordionStatus.Danger}
      icon={good ? 'good' : 'information'}
      header={
        <AccordionHeader
          title={t('Geofence Status')}
          subtitle={
            good ? t(transGood ?? 'GeofenceStatusGood') : t(transBad ?? 'GeofenceStatusBad')
          }
        />
      }
    >
      <AccordionTable
        hasRows={!!geofenceData.length}
        noRowsMessage={t('GeofenceStatusUnavailable')}
      >
        <GridControlled<GeofenceData>
          autoheight={true}
          sliceKey={gridSliceKeyGeofence}
          rowData={geofenceData}
          columnDefs={columnDefsGeofences}
          defaultColDef={lockColumn}
          getRowId={getRowIdGeofence}
          rowClassRules={geofenceRowClassRules}
        />
      </AccordionTable>
    </CasAccordion>
  );
}

export default GeofenceStatus;
